import axios, { CancelToken } from 'axios';

import { IFeedbackIA, IFeedbackPaginadoResponse, IGetFeedbacksParams, IUpdateFeedbackStatusPayload } from '../../../../pages/InteligenciaArtificial/interface';

import { getToken } from '../../../token';
import { GATEWAY_API_URL } from '../../../request/urls';

class FeedbackIAService {
    private baseURL = `${GATEWAY_API_URL}/backend-web`;

    async getFeedbacks(
        params?: IGetFeedbacksParams,
        signal?: CancelToken
    ): Promise<IFeedbackPaginadoResponse | IFeedbackIA[]> {
        const { data } = await axios.get(`${this.baseURL}/chat/feedback`, {
            params,
            headers: {
                Authorization: 'Bearer ' + getToken(),
            },
            cancelToken: signal,
        });

        return data;
    }

    async updateStatusFeedback(
        feedbackId: string | number,
        payload: IUpdateFeedbackStatusPayload,
        signal?: CancelToken
    ): Promise<any> {
        const { data } = await axios.patch(
            `${this.baseURL}/chat/feedback/${feedbackId}/status`,
            payload,
            {
                headers: {
                    Authorization: 'Bearer ' + getToken(),
                },
                cancelToken: signal,
            }
        );

        return data;
    }
}

export default new FeedbackIAService();
